module.exports = __webpack_public_path__ + "static/media/img_6.1f1d6fd1.jpg";